<div class="container">
  <h1>Password reset instructions</h1>
  <p>Check your email for further instructions.</p>
</div>
